// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"2bc9bf89","232":"4cea5337","787":"42e164e9"}[chunkId] + ".chunk.js";
};